(() => {
  const device = window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
  const trackNewsletter = (action, source, detail = {}) => {
    const payload = {
      action,
      source,
      device,
      page: window.location.pathname,
      ...detail,
    };

    window.dispatchEvent(new CustomEvent('hydros:newsletter', { detail: payload }));
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: `hydros_newsletter_${action}`,
        hydros_newsletter: payload,
      });
    }
  };

  const newsletterForms = document.querySelectorAll('form.hydros-club__form, form[data-hydros-newsletter-form]');

  const setNewsletterFeedback = (form, message, state) => {
    const feedback = form.querySelector('[data-hydros-newsletter-feedback]');
    if (!feedback) return;
    feedback.hidden = false;
    feedback.textContent = message;
    feedback.dataset.state = state;
  };

  const rememberNewsletterSubscription = (form) => {
    const promo = form.closest('[data-hydros-promo]');
    if (!promo) return;
    const popupVersion = promo.dataset.version || 'hydros-club-v1';
    try {
      window.localStorage.setItem(`hydros:club:${popupVersion}:subscribed`, 'true');
    } catch (error) {
      // The subscription remains valid when storage is unavailable.
    }
  };

  newsletterForms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      const source = form.classList.contains('hydros-club__form') ? 'modal' : form.dataset.newsletterSource || 'footer';
      const submitButton = form.querySelector('button[type="submit"]');
      const initialButtonLabel = submitButton?.textContent;
      trackNewsletter('submit', source);

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Inscription…';
      }
      form.setAttribute('aria-busy', 'true');

      try {
        const response = await window.fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        });
        const html = await response.text();
        const responseDocument = new DOMParser().parseFromString(html, 'text/html');
        const success = response.url.includes('customer_posted=true')
          || responseDocument.querySelector('[data-newsletter-result="success"]');
        const returnedError = responseDocument.querySelector('[data-newsletter-result="error"]');
        const verificationRequired = response.url.includes('/challenge')
          || responseDocument.querySelector('.shopify-challenge__container')
          || /connexion doit être vérifiée|connection needs to be verified/i.test(html);

        if (success) {
          form.reset();
          rememberNewsletterSubscription(form);
          setNewsletterFeedback(
            form,
            'Merci, votre inscription est confirmée. Votre code promo personnel offrant 10 % de réduction sur la commande suivante sera envoyé après votre première commande payée.',
            'success'
          );
          trackNewsletter('success', source);
        } else if (verificationRequired) {
          setNewsletterFeedback(form, 'Nous n’avons pas pu confirmer votre inscription. Rechargez la page puis réessayez dans un instant.', 'error');
          trackNewsletter('error', source, { reason: 'verification_required' });
        } else if (returnedError) {
          setNewsletterFeedback(form, returnedError.textContent.trim() || 'Cette adresse n’a pas pu être inscrite. Vérifiez-la puis réessayez.', 'error');
          trackNewsletter('error', source, { reason: 'shopify_error' });
        } else {
          setNewsletterFeedback(form, 'Cette inscription n’a pas pu être confirmée. Réessayez dans un instant.', 'error');
          trackNewsletter('error', source, { reason: 'unexpected_response' });
        }
      } catch (error) {
        setNewsletterFeedback(form, 'La connexion a été interrompue. Vérifiez votre réseau puis réessayez.', 'error');
        trackNewsletter('error', source, { reason: 'network_error' });
      } finally {
        form.removeAttribute('aria-busy');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = initialButtonLabel;
        }
      }
    });
  });

  document.querySelectorAll('[data-newsletter-result]').forEach((result) => {
    trackNewsletter(result.dataset.newsletterResult, result.dataset.newsletterSource || 'footer');
  });

  const popup = document.querySelector('[data-hydros-promo]');
  if (!popup) return;

  const dialog = popup.querySelector('[data-hydros-promo-dialog]');
  const teaser = popup.querySelector('[data-hydros-promo-teaser]');
  const delay = Number(popup.dataset.delay) || 10000;
  const scrollPercent = Number(popup.dataset.scroll) || 35;
  const memoryDays = device === 'mobile'
    ? Number(popup.dataset.memoryDaysMobile) || 21
    : Number(popup.dataset.memoryDays) || 14;
  const version = popup.dataset.version || 'hydros-club-v1';
  const storageKey = `hydros:club:${version}:dismissed`;
  const subscribedKey = `hydros:club:${version}:subscribed`;
  const isPreviewMode = new URLSearchParams(window.location.search).get('hydros_club') === 'preview';
  const excludedPaths = (popup.dataset.excludedPaths || '')
    .split(/[\n,]+/)
    .map((path) => path.trim())
    .filter(Boolean);
  let hasOpened = false;
  let lastFocusedElement = null;
  let timer;
  const earliestOpenAt = Date.now() + 2400;

  if (excludedPaths.some((path) => window.location.pathname.startsWith(path))) return;

  const readStorage = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const writeStorage = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // The experience remains usable when storage is unavailable.
    }
  };

  const wasRecentlyDismissed = () => {
    if (isPreviewMode) return false;
    const dismissedAt = Number(readStorage(storageKey));
    return dismissedAt > 0 && Date.now() - dismissedAt < memoryDays * 86400000;
  };

  const rememberDismissal = () => {
    writeStorage(storageKey, String(Date.now()));
  };

  const canShowTeaser = () => {
    if (popup.dataset.teaserEnabled !== 'true') return false;
    if (device === 'mobile' && popup.dataset.teaserMobile !== 'true') return false;
    return readStorage(subscribedKey) !== 'true';
  };

  const showTeaser = () => {
    if (!teaser || !canShowTeaser()) return;
    teaser.hidden = false;
    window.requestAnimationFrame(() => teaser.classList.add('is-visible'));
    trackNewsletter('teaser_view', 'teaser', { version });
  };

  const stopTriggers = () => {
    window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
  };

  const hasBlockingConsentDialog = () => Array.from(document.querySelectorAll('[role="alertdialog"]'))
    .some((element) => element.getClientRects().length > 0);

  const show = ({ force = false } = {}) => {
    if (!force && (hasOpened || wasRecentlyDismissed() || readStorage(subscribedKey) === 'true')) return;
    if (!force && Date.now() < earliestOpenAt) {
      timer = window.setTimeout(() => show(), earliestOpenAt - Date.now());
      return;
    }
    if (!force && hasBlockingConsentDialog()) {
      timer = window.setTimeout(() => show(), 1200);
      return;
    }
    hasOpened = true;
    stopTriggers();
    popup.hidden = false;
    if (teaser) {
      teaser.classList.remove('is-visible');
      teaser.hidden = true;
    }
    lastFocusedElement = document.activeElement;
    document.documentElement.classList.add('hydros-club-open');
    window.requestAnimationFrame(() => {
      popup.classList.add('is-open');
      dialog?.focus({ preventScroll: true });
    });
    trackNewsletter('view', 'modal', { version });
  };

  const dismiss = () => {
    rememberDismissal();
    stopTriggers();
    popup.classList.remove('is-open');
    document.documentElement.classList.remove('hydros-club-open');
    trackNewsletter('close', 'modal', { version });
    window.setTimeout(() => {
      if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus({ preventScroll: true });
      showTeaser();
    }, 240);
  };

  const onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    if ((window.scrollY / scrollable) * 100 >= scrollPercent) show();
  };

  popup.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-hydros-promo-close]');
    if (closeButton) {
      dismiss();
      return;
    }

    if (event.target.closest('[data-hydros-promo-teaser]')) {
      trackNewsletter('teaser_click', 'teaser', { version });
      show({ force: true });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      dismiss();
      return;
    }

    if (event.key !== 'Tab' || !popup.classList.contains('is-open') || !dialog) return;
    const focusable = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  popup.hidden = false;
  const modalResult = popup.querySelector('[data-newsletter-result]');
  if (modalResult?.dataset.newsletterResult === 'success') {
    writeStorage(subscribedKey, 'true');
    show({ force: true });
    return;
  }

  if (modalResult?.dataset.newsletterResult === 'error') {
    show({ force: true });
    return;
  }

  if (wasRecentlyDismissed()) {
    window.setTimeout(showTeaser, 900);
    return;
  }

  timer = window.setTimeout(() => show(), isPreviewMode ? 250 : delay);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
